import { Form } from 'antd'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { useEffect } from 'react'
import { useConfiguredFields } from '../../hooks/useConfiguredFields'
import ConfiguredFields from '../ConfiguredFields'
import type { ConfiguredFieldsFormProps } from './types'

/** Owns field-only submission and reports readiness to its enclosing form shell. */
function ConfiguredFieldsFormContent({
  formId,
  onStateChange,
  onSubmit,
  pending,
  session,
}: ConfiguredFieldsFormProps) {
  const {
    loading,
    onBlur,
    onChange,
    payItems,
    revealErrors,
    validation,
    values,
    visibleFieldIssues,
  } = useConfiguredFields(session)

  useEffect(() => {
    onStateChange({ valid: validation.valid, loading })
  }, [loading, onStateChange, validation.valid])

  const handleSubmit = async () => {
    if (pending || loading) return
    if (!validation.valid) {
      revealErrors()
      return
    }

    await onSubmit(validation.data)
  }

  return (
    <Form id={formId} layout="vertical" onFinish={handleSubmit}>
      <ConfiguredFields
        errors={visibleFieldIssues}
        fields={session.context.fields}
        formId={formId}
        onBlur={onBlur}
        onChange={onChange}
        payItems={payItems}
        pending={pending}
        values={values}
      />
    </Form>
  )
}

/** Supplies project pay-item options to a field form without an operation target. */
function ConfiguredFieldsForm(props: ConfiguredFieldsFormProps) {
  return (
    <PayItemSelectProvider
      skip={
        !props.session.context.fields.some(({ type }) => type === 'pay_items')
      }
    >
      <ConfiguredFieldsFormContent {...props} />
    </PayItemSelectProvider>
  )
}

export default ConfiguredFieldsForm
